import zhCN from 'root/locale/zh-cn.json';
import enUS from 'root/locale/en-us.json';

import zhCNSup from 'sup-ui/lib/locale-provider/zh_CN';
import enUSSup from 'sup-ui/lib/locale-provider/en_US';

export const local = [
  {
    locale: 'zh-cn',
    messages: zhCN
  },
  {
    locale: 'en-us',
    messages: enUS
  }
];

export const componentlocal = {
  'zh-cn': zhCNSup,
  en: enUSSup
};
